import { useEffect } from 'react';

// Drives the cursor-reactive spotlight on every .vh-edge card. One delegated,
// rAF-throttled pointer listener updates --mx/--my on whichever card is hovered,
// which the .vh-edge::after radial glow reads. Mount once per page (renders nothing).
export const CardSpotlight = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return undefined;
    }
    let raf = 0;
    let target = null;
    let lx = 0;
    let ly = 0;

    const apply = () => {
      raf = 0;
      if (!target) return;
      const r = target.getBoundingClientRect();
      if (!r.width || !r.height) return;
      target.style.setProperty('--mx', `${((lx - r.left) / r.width) * 100}%`);
      target.style.setProperty('--my', `${((ly - r.top) / r.height) * 100}%`);
    };

    const onMove = (e) => {
      const card = e.target && e.target.closest ? e.target.closest('.vh-edge') : null;
      if (!card) return;
      target = card;
      lx = e.clientX;
      ly = e.clientY;
      if (!raf) raf = requestAnimationFrame(apply);
    };

    document.addEventListener('pointermove', onMove, { passive: true });
    return () => {
      document.removeEventListener('pointermove', onMove);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return null;
};

export default CardSpotlight;
